const PAGE_SIZE = 10;

const REASON_CODE_FIRST_BALJU = 'first_balju';

const REASON_CODE_BALJU_TEST = 'balju_test';

const DEV_TEST_USER_ID_LIST = [
	'f5cd785a-65cc-4684-bea0-45b6005bca7b',
	'daad8fb3-90a2-4fa0-8a26-eeab8f75f408',
	'9705ba0e-fdea-459d-aa68-c83a4e311108',
	'b82f68d8-90b0-4d21-b676-fc5f8ee2c2cc',
	'83866ea0-2734-47a4-a792-5a62e0993cf4',
	'77c70b21-afbe-4814-b19c-2edda8efafc7',
	'ef7c129b-ed9b-4585-9178-8c69cbb2f395',
	'd83b9eaf-bccf-4d99-b6f5-4fb22026e36e',
	'9a380352-b937-4142-aa64-00fd18851d55',
	'6883a251-c804-4642-8add-1e9ecdb1c722',
	'1d9ff2f0-fa77-4024-9b0d-fbf64e42da8e',
	'20970ed3-7980-460a-b76f-28431ed0083a',
	'e72649e0-949e-4684-b50f-f8f0cea00148',
	'c0d4ec98-9447-420f-968d-7cebc20b96e6',
	'eca133c3-38bc-4370-bdd1-b328179d2f6d',
	'a18848ea-5783-4ec7-bc44-ddc55cc40300',
	'1c3ffc40-19e8-4692-9d2c-7c3ccbcf4ff6',
	'600f3f82-b2aa-4e25-8034-72f9a4d14a82',
	'6ecf379a-55dc-4dac-aa85-5a068c3fa370',
	'ce6119b7-0576-4aa7-9f8d-ce58d2d7cc75',
	'e5b8c921-2408-4dea-a8a9-c407c41d8b8e',
	'97075c50-36cc-4b6a-a316-9e8e4a48516c',
	'2e5b96ae-b9f5-410b-87fb-b3ab91dd0a1f',
	'99348802-d489-40e4-ac5a-14cc195ca487',
	'c76fed3d-e8dd-443f-a597-662abea823a1',
	'e74ff894-c75b-4023-93d4-dc7101a39347',
	'3174f9b6-4512-4077-a701-f843b7fc1313',
	'd35681f6-594f-4246-a436-2cf4d3aed630',
	'082f1316-a667-4a7f-ac15-d6453d5d2b41',
	'87286dd9-a189-42e5-b58a-f94e11828524',
	'4a6a8c42-e626-429a-b0f1-c34cdf0e1a4f',
	'0c2f178a-b253-44c4-9a55-584d15973b58',
	'94e81df0-8483-4d03-8c5e-3af937f4904f',
	'7dab5d1e-17e5-44ec-96f3-df02c2c8791b',
	'21b112a6-e1c8-4bc0-ab1b-0d756bb5881f',
	'7685cd22-9dd9-41ed-8c01-5cd9422e26d4',
	'55dbba3c-3778-4504-9078-df308ce4a8f8',
	'7f0ea776-837c-40f6-845b-142636fd2a68',
	'df808061-cdb2-4350-a0f5-e8ce8849edc3',
	'49fee45c-3f34-4495-85cf-af1964521039',
	'7b9a71df-8165-44f5-b7de-459fe28f9e56',
	'c8dd4924-7228-47e9-96d5-7af3d8c24b40',
	'1b171bfb-581d-47d7-ac53-7738438c707b',
	'085f1fed-e85c-4199-850b-e7c5966237d8',
	'541b9ec0-9c23-4778-9581-07084e70a734',
	'12785176-0b20-4d72-8940-fdc013b470a5',
	'ef977c5f-ea4f-4b7f-aa64-323d11958c59',
	'5288996b-9f9c-4f91-9943-90fb8fbdae50',
	'6715d268-4e6d-471b-8464-533e2ddac0bb',
	'257fc6fb-2425-4d87-9008-ca78b2d491ce',
];

const CALL_CENTER_GROUP_ID = 'e79e4a35-0c91-4f98-82e6-d027cf7ba878';


const constants = {
  PAGE_SIZE,
	REASON_CODE_FIRST_BALJU,
	REASON_CODE_BALJU_TEST,
	DEV_TEST_USER_ID_LIST,
	CALL_CENTER_GROUP_ID,
}

export default constants;
